import { useEffect } from 'react';
import { tutorialActions } from '@/utils/tutorials';

export interface UseBVActionsParams {
	openCreateBVModal: () => void;
	goToBVStep?: (step: number) => void;
	openBVActionHamburgerMenu?: () => void;
	addWound?: () => void;
	removeWound?: () => void;
}

export const useBVActions = ({
	openCreateBVModal,
	goToBVStep,
	openBVActionHamburgerMenu,
	addWound,
	removeWound,
}: UseBVActionsParams) => {
	useEffect(() => {
		const registerStepAction = (name: string, step: number) => {
			tutorialActions.register(name, () => {
				// Open the modal if it's closed (needed when going back from later steps)
				openCreateBVModal();
				if (goToBVStep) {
					// Use setTimeout to ensure modal is open before changing step
					setTimeout(() => {
						goToBVStep(step);
					}, 100);
				}
			});
		};

		// Actions declared in Benefit Verification tutorial JSON
		tutorialActions.register('openCreateBVModal', () => {
			// Open the demo BV modal and start on step 1.
			// We intentionally do NOT trigger the real "+ Submit New" button here
			// to avoid opening both the production form and the demo form at the same time.
			openCreateBVModal();
			if (goToBVStep) {
				goToBVStep(1);
			}
		});

		registerStepAction('openStep1BVModal', 1);
		registerStepAction('openStep2BVModal', 2);
		registerStepAction('openStep3BVModal', 3);
		registerStepAction('openStep4BVModal', 4);
		registerStepAction('openStep5BVModal', 5);
		registerStepAction('openStep6BVModal', 6);

		// Action to add a wound (used in tutorial step)
		tutorialActions.register('addWound2', () => {
			if (addWound) {
				addWound();
			}
		});

		// Action to remove wound 2 (used when going back from wound 2 step)
		tutorialActions.register('removeWound2', () => {
			if (removeWound) {
				removeWound();
			}
		});

		return () => {
			tutorialActions.unregister('openCreateBVModal');
			tutorialActions.unregister('openStep1BVModal');
			tutorialActions.unregister('openStep2BVModal');
			tutorialActions.unregister('openStep3BVModal');
			tutorialActions.unregister('openStep4BVModal');
			tutorialActions.unregister('openStep5BVModal');
			tutorialActions.unregister('openStep6BVModal');
			tutorialActions.unregister('addWound2');
			tutorialActions.unregister('removeWound2');
		};
	}, [openCreateBVModal, goToBVStep, openBVActionHamburgerMenu, addWound, removeWound]);
};

